import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { SettingsPaths } from "Pages/settings/paths";

import { TrustPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const TrustOverviewPage = lazy(() => import("./Pages/TrustOverview/TrustOverviewPage"));
const BusinessProfiles = lazy(
    () => import("Pages/settings/Pages/CallBranding/Pages/BusinessProfiles/BusinessProfiles")
);
const BrandingAndSpam = lazy(
    () => import("Pages/settings/Pages/CallBranding/Pages/BrandedPhoneNumbers/BrandedPhoneNumbers")
);

export const trustRoute: RegalRouteObject = {
    path: SettingsPaths.trust,
    element: <RVNestedRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Navigate to={TrustPaths.trustOverview} replace />,
        },
        {
            path: TrustPaths.trustOverview,
            element: <TrustOverviewPage />,
        },
        {
            path: TrustPaths.businessProfiles,
            element: <BusinessProfiles />,
        },
        {
            path: TrustPaths.brandingAndSpam,
            element: <BrandingAndSpam />,
        },
    ],
};
